module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Media/Pause-22384897b60b18cfc217289a82c817c7c28fcb1976b4db28f4e732a7e755f9d5.svg";